'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('react-intl-tel-input/dist/main.css');

require('./telephone.css');

var _base = require('../_base');

var _base2 = _interopRequireDefault(_base);

var _reactIntlTelInput = require('react-intl-tel-input');

var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

require('react-intl-tel-input/dist/libphonenumber.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// https://www.npmjs.com/package/react-intl-tel-input / http://patw0929.github.io/react-intl-tel-input/


var GeckoFieldTelephone = function (_GeckoFieldBase) {
	_inherits(GeckoFieldTelephone, _GeckoFieldBase);

	function GeckoFieldTelephone() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, GeckoFieldTelephone);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoFieldTelephone.__proto__ || Object.getPrototypeOf(GeckoFieldTelephone)).call.apply(_ref, [this].concat(args))), _this), _this.inputs = [{
			key: 'country_code'
		}, {
			key: 'number'
		}], _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(GeckoFieldTelephone, [{
		key: 'handleChange',
		value: function handleChange(status, value, data, number, id) {
			return this.props.handler.bind(this, this.field().key, this.prepareValue(value, data, number))();
		}
	}, {
		key: 'prepareValue',
		value: function prepareValue(value, data, number) {
			return {
				number: number,
				country_code: data.iso2
			};
		}
	}, {
		key: 'attrs',
		value: function attrs() {
			var _telInputProps;

			return {
				telInputProps: (_telInputProps = {}, _defineProperty(_telInputProps, 'aria-label', this.renderAriaLabel()), _defineProperty(_telInputProps, 'autoComplete', 'tel'), _telInputProps),
				placeholder: this.config().placeholder,
				preferredCountries: this.config().preferredCountries || ['gb'],
				onlyCountries: this.config().onlyCountries || [],
				excludeCountries: this.config().excludeCountries || [],
				css: ['intl-tel-input', 'form-control'],
				nationalMode: false,
				format: true,
				utilsScript: 'libphonenumber.js',
				fieldId: this.renderId(),
				onPhoneNumberChange: this.handleChange.bind(this),
				onPhoneNumberBlur: this.handleBlur.bind(this),
				disabled: this.isDisabled(),
				value: this.jsonValue().number
			};
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(_reactIntlTelInput2.default, this.attrs());
		}
	}]);

	return GeckoFieldTelephone;
}(_base2.default);

exports.default = GeckoFieldTelephone;
